import { render, staticRenderFns } from "./TDSInputField.vue?vue&type=template&id=625bb5f5&scoped=true"
import script from "./TDSInputField.vue?vue&type=script&lang=ts"
export * from "./TDSInputField.vue?vue&type=script&lang=ts"
import style0 from "./TDSInputField.vue?vue&type=style&index=0&id=625bb5f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625bb5f5",
  null
  
)

export default component.exports